import { loadingStore, notificationStore, parseNumberByPrecision, RoundStatus } from '@pascal/pascal-core';
import {
  betStore,
  gameConfigStore,
  gameResultStore,
  popupStore,
  roundInfoStore,
  userInfoStore,
} from '@pascal/pascal-core/shared/core/store';

import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import { worker } from '../index';
import { liveConnection } from '../core';
import { RESULTS_LIST_LENGTH } from '../enums';
import { diceAnimations } from './DiceAnimations';
import { chestAnimations } from './ChestAnimations';
import { dancerAnimations } from './DancerAnimations';
import { gameLiveConnection } from './GameConnection';
import { soundService, soundTypes } from './soundService';
import { doBetStore, gameStore, roundTimeStore } from '../store';

let timeOutId;

class GameService {
  roundFinishedTimeOutId = null;

  onGetInitialStateResult({ limits, results, roundInfo, currentBets, gameConfiguration }) {
    const { Started, Finished, OnFinish } = RoundStatus;
    const { status, second, duration } = roundInfo;

    // chestAnimations.clearOpenTrack();
    // chestAnimations.clearCloseTrack();
    // chestAnimations.clearTracks();
    // dancerAnimations.startBlinkAnimation(0, true);
    // chestAnimations.startStaticAnimation(false);
    // diceAnimations.destroy();

    roundTimeStore.resetRoundTimeData();
    gameStore.setIsBetsClosed(false);
    gameStore.setFinishedResult(null);
    gameStore.setIsRoundFin(false);
    gameStore.setFixNumber(null, true);
    doBetStore.setRangeValues([]);
    betStore.setLiveBets([]);
    gameStore.setGameState({
      status,
      isInitialLoaded: true,
    });

    if (currentBets && currentBets?.length) {
      betStore.setLiveBets(currentBets);
    }

    if (second < -2) {
      gameStore.setAnimationTime(second + 2);
    } else {
      gameStore.setAnimationTime(0);
    }

    if (status === Started) {
      const isBetClosed = second < 0 || second === 0;
      if (isBetClosed) {
        doBetStore.updateIsDisabledBetSection(true);
        gameStore.setIsBetsClosed(true);
      }
      doBetStore.setWinAmount('');
    } else if (status === Finished || status === OnFinish) {
      let currentTotalWinAmount;
      gameStore.setIsRoundFin(true);

      if (currentBets && currentBets.length) {
        currentTotalWinAmount = currentBets
          .filter((item) => item?.playerExternalId === userInfoStore.playerExternalId && !item.winAmount)
          .reduce((acc, curr) => acc + parseNumberByPrecision(Number(curr?.winAmount), 1, 2), 0);
      }
      doBetStore.setWinAmount(currentTotalWinAmount);
    }

    roundInfoStore.setDuration(duration);

    gameResultStore.setGameResults(results);

    roundInfoStore.setRoundInfo(roundInfo);
    gameConfigStore.setLimits(limits);

    const data = gameResultStore.gameResults.filter((result) => result.roundData).slice(0, RESULTS_LIST_LENGTH);
    gameStore.setPastRoundsData(data);
    gameStore.setMargin(gameConfiguration.margin);

    if (RoundStatus.Started === roundInfo.status && roundInfo.second > 0) {
      gameStore.setTimerDuration(roundInfo.second);
      roundTimeStore.setPassedSeconds(second);
      setTimeout(() => {
        gameStore.setIsRoundFin(true);
      }, second * 1000);
      const time = Math.floor(Math.abs(roundInfo.second));
      roundTimeStore.setTime(time);
      this.sendWorker(time);
    } else {
      this.sendWorker();
      setTimeout(() => gameStore.setIsRoundFin(true), second * 1000);
      gameStore.setTimerDuration(roundInfo.duration);
      roundTimeStore.setTime(null);
    }

    loadingStore.updateLoading({ isGameInitialLoaded: true });
    popupStore.close();
    popupStore.toggleReconnect(false);
  }

  handleDoBetResult(data) {
    const { userId } = userInfoStore;

    if (Number(userId) === Number(+data.userId)) {
      const { isSoundOn } = userSettingsStore;
      if (isSoundOn) {
        soundService.playBetAccepted();
      }
      doBetStore.handleDoBetResult(data);
      doBetStore.updateIsDisabledBetSection(false);
    }
    betStore.updateLiveBets(data);
  }

  // eslint-disable-next-line class-methods-use-this
  handleDoBetResultValidation(data) {
    const { responseCode } = data;
    doBetStore.updateIsDisabledBetSection(false);
    doBetStore.setIsLoadingBetButton(false);
    notificationStore.setNotificationType({ responseCode });
  }

  handleRoundStart({ data: { startedRound, results } }) {
    const { roundId } = startedRound;
    roundTimeStore.resetRoundTimeData();
    gameStore.setIsRoundFin(false);
    gameStore.setIsBetsClosed(false);
    gameStore.setFinishedResult(null);
    gameStore.setFixNumber(null, true);
    gameStore.setAnimationTime(0);
    doBetStore.setWinAmount('');
    this.sendWorker(roundInfoStore.duration);

    gameStore.setGameState({
      status: RoundStatus.Started,
      isInitialLoaded: false,
    });

    gameResultStore.setGameResults(results);
    betStore.setLiveBets([]);

    roundInfoStore.setRoundId(roundId);
  }

  // eslint-disable-next-line class-methods-use-this
  handleRoundFin({ data }) {
    const {
      bets,
      finishedRound: { roundData },
    } = data;
    const { userId } = userInfoStore;
    // const { isDemo } = applicationStore;
    const { animationTime } = gameStore;
    // const {
    //   limits: { maxWin },
    // } = gameConfigStore;

    // const { Lose, Win } = BetStatus;
    let updatedRealLiveBets = [];
    // let demoBets = [];

    gameStore.setIsAnim(true);
    gameStore.setFixNumber(5, true);

    chestAnimations.setIsCleared(false);
    const { isCleared } = chestAnimations;
    // if (!isCleared) {
    const winNumber = roundData?.reduce((acc, current) => acc + current);
    gameStore.incrementFixNumber(winNumber);
    diceAnimations.setDices(roundData).then((res) => {
      if (res) {
        if (!isCleared) {
          chestAnimations.startOpenAnimation(animationTime);
          setTimeout(() => soundService.play(soundTypes.openBox), 1800);
          if (!isCleared) {
            dancerAnimations.startOpenAnimation(animationTime);
            if (!isCleared) {
              diceAnimations.setDicesAnimation(animationTime).then((diceDelay) => {
                if (!isCleared) {
                  diceAnimations
                    .rearrangeDicesAnimation(diceDelay)
                    .then((rearrangeDelay) => !isCleared && diceAnimations.hideDices(rearrangeDelay))
                    .then((hideDelay) => !isCleared && chestAnimations.startCloseAnimation(hideDelay));
                }
              });
            }
          }
        }
      }
    });
    // }

    // if (isDemo) {
    //   demoBets = betStore?.liveBets
    //     ?.filter((item) => !item?.playerExternalId)
    //     .map((bet) => {
    //       const isWon = bet.betData.some((item) => item.from <= winNumber && item.to >= winNumber);
    //       return {
    //         ...bet,
    //         winAmount: isWon ? parseNumberByPrecision(bet.odd, +bet.amount, 2) : 0,
    //         status: isWon ? Win : Lose,
    //       };
    //     });
    //   const currentTotalWinAmount = demoBets
    //     ?.filter((item) => item?.status === Win)
    //     .reduce((acc, curr) => acc + +curr.winAmount, 0);
    //
    //   if (currentTotalWinAmount) {
    //     let validDemoWinAmount;
    //     if (Number(currentTotalWinAmount) > maxWin) {
    //       validDemoWinAmount = maxWin;
    //       notificationStore.setNotificationType({ responseCode: BetResponseCode.MaxWinPayout });
    //     } else {
    //       validDemoWinAmount = Number(currentTotalWinAmount);
    //     }
    //     setTimeout(() => {
    //       soundService.playWin();
    //       dancerAnimations.startWinAnimation();
    //       doBetStore.setWinAmount(parseNumberByPrecision(1, validDemoWinAmount));
    //       doBetStore.increaseDemoBalance(parseNumberByPrecision(1, validDemoWinAmount), 1);
    //     }, 4000);
    //   }
    // }

    if (bets.length) {
      const myBets = bets.filter((bet) => bet.userId === +userId);
      if (myBets.length) {
        const myWinAmount = myBets.reduce(
          (acc, curr) => acc + parseNumberByPrecision(Number(curr?.winAmount), 1, 2),
          0
        );

        setTimeout(() => {
          if (myWinAmount) {
            soundService.playWin();
          }
          dancerAnimations.startWinAnimation();
          doBetStore.setWinAmount(parseNumberByPrecision(1, myWinAmount, 2));
        }, 4000);
      }
    }

    updatedRealLiveBets = bets.map((item) => {
      return {
        ...item,
        betData: { ...item?.additionalParams },
      };
    });

    const resultsForSlice = {
      roundId: roundInfoStore.roundId,
      anim: true,
      roundData,
    };

    this.roundFinishedTimeOutId = setTimeout(() => {
      gameStore.setFinishedResult(roundData);
      gameStore.setPastRoundsData(resultsForSlice);
      gameStore.setIsRoundFin(true);
      gameStore.setIsAnim(false);
      // if (isDemo) {
      //   betStore.updateDemoBetHistory(demoBets);
      // }
      betStore.setLiveBets([...updatedRealLiveBets]);
      doBetStore.updateTotalBetsAmount(0, true);
    }, 4000);
  }

  // eslint-disable-next-line class-methods-use-this
  handleBetsClosed() {
    gameStore.setIsBetsClosed(true);
    gameStore.setGameState({
      status: '',
      isInitialLoaded: false,
    });
    doBetStore.setIsLoadingBetButton(false);
    doBetStore.updateIsDisabledBetSection(true);
    soundService.play(soundTypes.shuffle);
    chestAnimations.startShakeAnimation();
  }

  // eslint-disable-next-line class-methods-use-this
  countDown({ data: time }) {
    roundTimeStore.setTime(time);
  }

  // eslint-disable-next-line class-methods-use-this
  handleReconnecting(error) {
    if (error && error.message) {
      popupStore.toggleReconnect();
    } else {
      GameService.ReconnectCount += 1;
      popupStore.toggleReconnect();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleReconnected() {
    GameService.ReconnectCount = 0;
    gameLiveConnection.sendGameGetInitialState(false);
  }

  // eslint-disable-next-line class-methods-use-this
  handleConnectionError() {
    if (GameService.ReconnectCount) {
      popupStore.onConnectionError(true);
    }
  }

  socketRecursiveReconnecting() {
    try {
      liveConnection
        .restartGameConnection()
        .then((connectionData) => {
          liveConnection.connectionInitCallback(connectionData);
          clearTimeout(timeOutId);
        })
        .catch(() => {
          timeOutId = setTimeout(() => {
            this.socketRecursiveReconnecting();
          }, 4000);
        });
    } catch (err) {
      popupStore.onConnectionError(true);
    }
  }

  sendWorker(timerValue) {
    if (timerValue) {
      worker.addEventListener('message', this.countDown);
      worker.postMessage(timerValue);
    } else {
      worker.removeEventListener('message', this.countDown);
    }
  }
}

export const gameService = new GameService();
